import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';

var _components;

import './index.css';
import {getComponentName} from '../../common/utils/namespace';
import {createNamespace} from '../../common/utils';
import loading from '../loading';
import icon from '../icon';
import VueOverlay from '../overlay';
import Vue from 'vue';

var _createNamespace = createNamespace('toast'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

export default {
    name: getComponentName('Toast'),
    data: function data() {
        return {
            timer: null,
            $overlay: null
        };
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    components:
        ((_components = {}),
        _defineProperty(_components, loading.name, loading),
        _defineProperty(_components, icon.name, icon),
        _components),
    props: {
        round: Boolean,
        value: {
            type: Boolean
        },
        duration: {
            type: [Number, String],
            default: 300
        },
        type: {
            type: String,
            default: 'text'
        },
        text: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: ''
        },
        container: {
            type: Function,
            default: function _default() {
                return document.body;
            }
        }
    },
    watch: {
        value: function value(val) {
            if (val) {
                this.handleDuration();
            } else {
                this.$overlay.show = false;
            }
        }
    },
    methods: {
        overlay: function overlay() {
            var overlayConstructor = Vue.extend(VueOverlay);
            var div = document.createElement('div');
            this.container().appendChild(div);
            this.$overlay = new overlayConstructor({
                propsData: {
                    show: this.value,
                    transparent: true
                }
            }).$mount(div);
        },
        removeOverlay: function removeOverlay() {
            this.$overlay.show = false;
            this.container().removeChild(this.$overlay.$el);
            this.$overlay.$destroy();
        },
        getIcon: function getIcon() {
            var h = this.$createElement;
            var icon = this.icon,
                type = this.type,
                iconPrefix = this.iconPrefix,
                loadingType = this.loadingType;
            var hasIcon = icon || type === 'success' || type === 'fail';
            var iconMap = {
                success: 'success',
                fail: 'close'
            };

            if (hasIcon) {
                return h('mai-icon', {
                    class: b('icon'),
                    attrs: {
                        classPrefix: iconPrefix,
                        name: icon || iconMap[type]
                    }
                });
            }

            if (type === 'loading') {
                return h('mai-loading', {
                    class: b('loading'),
                    attrs: {
                        type: loadingType
                    }
                });
            }
        },
        getText: function getText(h) {
            var elTagName = 'div';
            return h(
                elTagName,
                {
                    class: b('text')
                },
                this.text || (this.$slots.default && this.$slots.default)
            );
        },
        handleDuration: function handleDuration() {
            var _this = this;

            if (this.duration > 0) {
                this.timer = setTimeout(function() {
                    _this.close();

                    _this.timer && clearTimeout(_this.timer);
                }, this.duration);
            }
        },
        close: function close() {
            this.$emit('change', false);
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.removeOverlay();
    },
    created: function created() {
        this.overlay();
    },
    render: function render(h) {
        var _this$$props = this.$props,
            type = _this$$props.type,
            round = _this$$props.round;
        var classes = [];
        classes.push(type);
        round && classes.push('round');

        if (this.value) {
            this.$overlay.show = true;
        }

        return h(
            'div',
            {
                class: b(classes),
                directives: [
                    {
                        name: 'show',
                        value: this.value
                    }
                ]
            },
            [this.getIcon(), this.getText(h)]
        );
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
